import { Enumify } from "enumify-ts";
class MarketplaceBillingInvoiceFrequency extends Enumify() {
    description;
    static DAILY = new MarketplaceBillingInvoiceFrequency("Daily");
    static WEEKLY = new MarketplaceBillingInvoiceFrequency("Weekly");
    static MONTHLY_INVOICED_WEEKLY = new MarketplaceBillingInvoiceFrequency("Weekly (plus end of month)");
    static MONTHLY = new MarketplaceBillingInvoiceFrequency("Monthly");
    static _ = MarketplaceBillingInvoiceFrequency._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return MarketplaceBillingInvoiceFrequency.values.map(r => {
            return {
                label: r.description,
                value: r.key
            };
        });
    }
}
export default MarketplaceBillingInvoiceFrequency;
